import React from "react";

type Props = {
    src: string;
    alt?: string;
};
const Icon = ({src, alt}: Props) => (<img src={src} alt={alt} className="float-left w-[35px] h-[35px] mr-[10px]"/>);

export default Icon;
